import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import Modal from '../shared/Modal';
import TextInput from '../InputComponent/TextInput';
import TextAreaInput from '../InputComponent/TextAreaInput';
import SelectInput from '../InputComponent/SelectInput';
import { cleanObject } from '../CleanObject';

const AddEnquiryModal = ({ isOpen, onClose, onSave, trainers, programs }) => {
    const initialFormState = {
        name: '',
        phone: '',
        email: '',
        preferred_programs: [],
        fitness_goal: '',
        source: 'Walk-in',
        trainer_assigned: '',
        remarks: '',
    };

    const [formData, setFormData] = useState(initialFormState);

    useEffect(() => {
        if (isOpen) {
            setFormData(initialFormState);
        }
    }, [isOpen]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name == "phone") {
            const digits = value.replace(/\D/g, "");
            setFormData(prev => ({ ...prev, [name]: digits }));
            return;
        }

        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleProgramToggle = (programName) => {
        setFormData(prev => {
            const selected = prev.preferred_programs;
            if (selected.includes(programName)) {
                return { ...prev, preferred_programs: selected.filter(p => p !== programName) };
            }
            return { ...prev, preferred_programs: [...selected, programName] };
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(formData.phone);

        if (!formData.name || !formData.phone) {
            toast.error('Full Name and Contact Number are required.');
            return;
        }
        if (formData.phone.length < 7) {
            toast.error('Please enter at least 7 digit mobile number');
            return;
        }
        if (formData.phone.length > 11) {
            toast.error('Mobile number cannot exceed 11 digits');
            return;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(formData.email)) {
            toast.error("Please enter a valid email address");
            return;
        }
        let cleanObj = cleanObject({
            name: formData.name,
            phone: formData.phone,
            email: formData.email,
            preferred_programs: formData.preferred_programs,
            fitness_goal: formData.fitness_goal,
            source: formData.source,
            trainer_assigned: formData.trainer_assigned,
            remarks: formData.remarks,
        })
        onSave(cleanObj);
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Add New Enquiry">
            <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <TextInput label={"Full Name"} name="name" value={formData.name} onChange={handleChange} type="text" isRequired={true} />
                    <TextInput label={"Contact Number"} name="phone" value={formData.phone} onChange={handleChange} type="number" isRequired={true} />
                </div>
                <TextInput label={"Email Address"} name="email" type="email" value={formData.email} onChange={handleChange} isRequired={true} />
                <TextAreaInput label={"Fitness Goal"} name="fitness_goal" value={formData.fitness_goal} onChange={handleChange} rows="2" />

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <SelectInput
                        label="Source of Enquiry"
                        name="source"
                        value={formData.source}
                        onChange={handleChange} 
                        options={["Walk-in", "Phone", "Social Media", "Referral"]}
                    >
                        <option>Walk-in</option>
                        <option>Phone</option>
                        <option>Social Media</option>
                        <option>Referral</option>
                    </SelectInput>
                    <SelectInput label="Assign Trainer" name="trainer_assigned" value={formData.trainer_assigned} onChange={handleChange}  options={trainers}>
                        <option value={''}>None</option>
                        {trainers.map(trainer => (
                            <option key={trainer.id} value={trainer.id}>{trainer.name}</option>
                        ))}
                    </SelectInput>
                </div>
                <TextAreaInput label={"Remarks"} name="remarks" value={formData.remarks} onChange={handleChange} rows="2" />
                <div className="pt-4 flex justify-end gap-3">
                    <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300">Cancel</button>
                    <button type="submit" className="px-4 py-2 bg-brand-red text-white rounded-lg hover:bg-red-600">Save Enquiry</button>
                </div>
            </form>
        </Modal>
    );
};

export default AddEnquiryModal;
